<template>
  <div ref="echarts-evento-sazonalidade-periodo-analise" style="width: 100%; height: 100%;"></div>
</template>

<script>
import { nextTick } from "vue";
import * as echarts from 'echarts';
import { opcoes } from './Opcoes';
import { mapGetters } from 'vuex';

let myChartAnalisePeriodo;

export default {
  computed: {
    ...mapGetters({
      GET_DIALOG_GRAFICO_TABELA: 'EventoSazonalFinal/GET_DIALOG_GRAFICO_TABELA',
      GET_DADOS_GRAFICO_TABELA: 'EventoSazonalFinal/GET_DADOS_GRAFICO_TABELA',
    }),
  },
  watch: {
    GET_DIALOG_GRAFICO_TABELA(valor) {
      if (valor) this.buscarDadosGrafico();
    },
    "GET_DADOS_GRAFICO_TABELA.anos": 'criacaoDestruicaoGrafico',
  },
  created() {
    this.buscarDadosGrafico();
  },
  mounted() {
    this.iniciarGrafico();
  },
  methods: {
    criacaoDestruicaoGrafico() {
      myChartAnalisePeriodo.dispose();
      this.iniciarGrafico();
      this.atualizarDadosGrafico();
    },
    iniciarGrafico() {
      myChartAnalisePeriodo = echarts.init(this.$refs['echarts-evento-sazonalidade-periodo-analise']);

      async () => {
        await nextTick();
        myChartAnalisePeriodo.resize();
      }

      this.redimencionarGraficoSempreQueTamanhoTelaMudar();
    },
    buscarDadosGrafico() {
      this.$store.dispatch('EventoSazonalFinal/buscarDadosGrafico');
    },
    atualizarDadosGrafico() {
      const opt_fixa = Object.assign({}, opcoes);
      const dinamico = this.GET_DADOS_GRAFICO_TABELA;
      const series = dinamico.grafico;
      const label = dinamico.label;

      const opt = {
        ...opt_fixa,
        legend: { padding: 20 },
        xAxis: {
          ...dinamico.xAxis,
          data: label
        },
        series: series
      }

      myChartAnalisePeriodo.setOption(opt);
      myChartAnalisePeriodo.resize();
    },
    redimencionarGraficoSempreQueTamanhoTelaMudar() {
      window.addEventListener('resize', function() {
        myChartAnalisePeriodo.resize();
      });
    },
  },
}
</script>

<style>

</style>
